import type { ChipProps } from '@material-ui/core/Chip';
import Chip from '@material-ui/core/Chip';
import type { GridSpacing } from '@material-ui/core/Grid';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import MyIcon from 'components/Icon';
import React from 'react';

import type { IInvoice, IInvoiceTags } from 'v2/interfaces/invoice';

import useStyles from './styles';

type ChipPropsExtends = 'size' | 'variant';

interface IProps extends Pick<ChipProps, ChipPropsExtends> {
  invoice: IInvoice;
  spacing?: GridSpacing;
}

export const getIfAtLeastOneTagIsTrue = (tags = {} as IInvoiceTags) => {
  return Object.values(tags).some((tag) => !!tag);
};

const InvoiceTags = ({ size = 'medium', variant = 'outlined', invoice, spacing = 2 }: IProps) => {
  const styleProps = { size };
  const classes = useStyles(styleProps);

  const hasNoTags = !getIfAtLeastOneTagIsTrue(invoice?.tags);

  if (hasNoTags || !invoice) return null;

  const chipDefaultProps = {
    size,
    variant,
    classes: {
      root: classes.chipRoot,
      label: classes.chipLabel,
      deleteIcon: classes.chipDeleteIcon,
    },
    onDelete: () => ({}),
  };

  const { tags } = invoice;

  return (
    <Grid container spacing={spacing}>
      {tags.is_terminal && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Maquininha' deleteIcon={<Icon className={classes.customIcon}>aod</Icon>} />
        </Grid>
      )}
      {tags?.upsell && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Upsell' deleteIcon={<MyIcon className='icon' name='icon-upsell' />} />
        </Grid>
      )}
      {tags?.order_bump && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Order Bump' deleteIcon={<MyIcon className='icon' name='icon-order-bump' />} />
        </Grid>
      )}
      {tags?.quick_sale && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Venda Rápida' deleteIcon={<MyIcon name='icon-vendarapida' file={true} />} />
        </Grid>
      )}
      {tags?.chargeback && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Chargeback' deleteIcon={<Icon className={classes.customIcon}>flag</Icon>} />
        </Grid>
      )}
      {tags?.partial_refund && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Reembolso Parcial' deleteIcon={<Icon className={classes.customIcon}>money_off</Icon>} />
        </Grid>
      )}
      {tags?.recovered && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Venda Recuperada' deleteIcon={<MyIcon className='icon' name='icon-recuperacao' />} />
        </Grid>
      )}
      {tags?.multiple_cards && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Múltiplos Cartões' deleteIcon={<MyIcon className='icon' name='icon-multiplos-cartoes' />} />
        </Grid>
      )}
      {tags?.interest_free_installment && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Parcelamento sem juros' deleteIcon={<MyIcon className='icon' name='icon-parcelamento-semjuros' />} />
        </Grid>
      )}
      {tags?.unlimited_installment && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Parcelamento sem limite' deleteIcon={<MyIcon className='icon' name='icon-parcelamento-semlimites' />} />
        </Grid>
      )}
      {tags?.infinite_funnel && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Funil Infinito' deleteIcon={<MyIcon className='icon' name='icon-funil-infinito' />} />
        </Grid>
      )}
      {tags?.recurrence && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Recorrência' deleteIcon={<MyIcon className='icon' name='icon-assinaturas' />} />
        </Grid>
      )}
      {tags?.coupon && (
        <Grid item>
          <Chip {...chipDefaultProps} label={tags?.coupon} deleteIcon={<MyIcon className='icon' name='icon-cupom' />} />
        </Grid>
      )}
      {tags?.courtesy_recovered && (
        <Grid item>
          <Chip {...chipDefaultProps} label='Cortesia Recuperação' deleteIcon={<MyIcon className='icon' name='icon-recuperada-cortesia' />} />
        </Grid>
      )}
      {tags?.free && (
        <Grid item>
          <Chip
            size={chipDefaultProps.size}
            variant={chipDefaultProps.variant}
            className={`${classes.chipRoot} ${classes.chipLabel}`}
            label='Gratuito'
          />
        </Grid>
      )}
      {tags?.one_click_buy && (
        <Grid item>
          <Chip {...chipDefaultProps} label='One Click Buy' deleteIcon={<MyIcon className='icon' name='one-click-buy' />} />
        </Grid>
      )}
    </Grid>
  );
};

export default InvoiceTags;
